<!-- Formulaire de gestion du compte -->

<form [formGroup]="form" (ngSubmit)="formService.submit()" class="form_account">

    <div class="infos_user">
        <div class="row h_full">
            <div class="col y_items_center">
                <span class="name"><span>{{ user.value.firstName.charAt(0) }}{{ user.value.lastName.charAt(0) }}</span>{{ user.value.firstName }} {{ user.value.lastName }}</span>
            </div>
        </div>
    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group #tabGroup>
        @for(tabItem of tabItems; track tabItem) {
            <mat-tab >
                <ng-template  mat-tab-label>
                    <span>{{ tabItem.label | translate }}</span>
                    <span  [ngClass]="offerFormTabValidationService.getTabLabelClass(tabItem.tag)"></span>
                </ng-template>
                <ng-container *ngTemplateOutlet="tabItem.template"></ng-container>
            </mat-tab>
        }
    </mat-tab-group>

</form>

<!-- Données personnelles -->

<ng-template #personnalInformations>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'user.account.personnalInformations.value' | translate }}</span>
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="content_tab">

        <ng-container [formGroup]="form">

            <div class="row marges ligne_form">
                <div class="col_12">

                    <!-- Identifiant unique -->

                    <div class="form-group">
                        <label>{{'form.user.fields.id.title.value' | translate}} : {{user.getValue().id}}</label>
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12">

                    <!-- Civilité -->

                    <div class="form-group">
                        <label>{{'form.user.fields.civility.title.value' | translate}}</label>
                        <div class="radio">
                            <input type="radio" [value]="1" formControlName="civility" class="form-control" id="civility-mister">
                            <label for="civility-mister">{{'form.user.fields.civility.mister.value' | translate}}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="2" formControlName="civility" class="form-control" id="civility-madam">
                            <label for="civility-madam">{{'form.user.fields.civility.madam.value' | translate}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row marges ligne_form">
                <div class="col_12 col_md_4">

                    <!-- Nom -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="lastName" id="lastName" required="required">
                        <label for="lastName">{{'form.user.fields.lastname.value' | translate}}</label>
                        @if(form.get('lastName').errors && (form.get('lastName').dirty || form.get('lastName').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('lastName').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
                <div class="col_12 col_md_4">

                    <!-- Prénom -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="firstName" id="firstName" required="required">
                        <label for="firstName">{{'form.user.fields.firstname.value' | translate}}</label>
                        @if(form.get('firstName').errors && (form.get('firstName').dirty || form.get('firstName').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('firstName').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
                <div class="col_12 col_md_4">

                    <!-- Email -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="email" id="userEmail" required="required">
                        <label for="userEmail">{{'form.user.fields.email.contact.value' | translate}}</label>
                        @if(form.get('email').errors && (form.get('email').dirty || form.get('email').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('email').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(form.get('email').errors.pattern) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>
            <div class="row marges ligne_form">
                <div class="col_12 col_md_4">

                    <!-- Téléphone fixe -->

                    <div class="form-group">

                        <app-core-intl-tel-input [formGroup]="form" [controlName]="'switchboardPhone'" customPlaceholder="{{'form.user.fields.switchboardPhone.value' | translate}}"></app-core-intl-tel-input>

                        @if(form.get('switchboardPhone').errors && (form.get('switchboardPhone').dirty || form.get('switchboardPhone').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('switchboardPhone').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(form.get('switchboardPhone').errors.validatePhoneNumber) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
                <div class="col_12 col_md_4">

                    <!-- Ligne directe -->

                    <div class="form-group">

                        <app-core-intl-tel-input [formGroup]="form" [controlName]="'directPhone'" customPlaceholder="{{'form.user.fields.directPhone.value' | translate}}"></app-core-intl-tel-input>

                        @if(form.get('directPhone').errors && (form.get('directPhone').dirty || form.get('directPhone').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('directPhone').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(form.get('directPhone').errors.validatePhoneNumber) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
                <div class="col_12 col_md_4">

                    <!-- Portable -->

                    <div class="form-group">

                        <app-core-intl-tel-input [formGroup]="form" [controlName]="'cellphone'" customPlaceholder="{{'form.user.fields.cellphone.value' | translate}}"></app-core-intl-tel-input>

                        @if(form.get('cellphone').errors && (form.get('cellphone').dirty || form.get('cellphone').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('cellphone').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                    @if(form.get('cellphone').errors.validatePhoneNumber) {
                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">

                <div class="col_12 col_md_4">
                    <div class="form-group">
                        <app-core-timezone-select [form]="form" [required]="true"></app-core-timezone-select>
                    </div>
                </div>

                <div class="col_12 col_md_4">

                    <!-- Service -->

                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="service" id="service">
                        <label for="service">{{ (isAccountAdmin() ? 'form.user.fields.service.value' : 'collaborator.list.fields.service.value') | translate}}</label>
                        @if(form.get('service').errors &&(form.get('service').dirty || form.get('service').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('service').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>

                <div class="col_12 col_md_4">

                    <!-- Locale -->

                    <div class="form-group">
                        <select class="form-control" id="adminLocale" formControlName="locale" required="required">
                            <option value=""></option>
                            @for((locale of locales$ | async); track locale) {
                                <option [value]="locale.id">
                                    {{ locale.label | translate }}
                                </option>
                            }
                        </select>
                        <label class="required" for="locale">{{ 'form.user.fields.locale.value' | translate }}</label>
                        @if(form.get('locale').errors && (form.get('locale').dirty || form.get('locale').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('locale').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

        </ng-container>

    </div>

</ng-template>

<!-- Saisie des informations entreprise -->

<ng-template #societyInformations>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'society.informations.value' | translate }}</span>
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="content_tab">

        <ng-container [formGroup]="form">

            @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_PROVIDER'])) {
                <p>{{ 'services.form.file.infos.society.value' | translate}} </p>

                <br/>
            }

            <div formGroupName="society">

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Nom société -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="name" id="nameSociety" required="required">
                            <label for="nameSociety">{{'form.user.fields.name.value' | translate}}</label>
                            @if(societyForm.get('name').errors && (societyForm.get('name').dirty || societyForm.get('name').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('name').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col_12 col_md_6">

                        <!-- Site web -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="mainWebsite" id="mainWebsite" required="required">
                            <label for="mainWebsite">{{'form.user.fields.website.value' | translate}}</label>
                            @if(societyForm.get('mainWebsite').errors && (societyForm.get('mainWebsite').dirty || societyForm.get('mainWebsite').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('mainWebsite').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyForm.get('mainWebsite').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Locale -->

                        <div class="form-group">
                            <select class="form-control" id="locale" formControlName="locale" required="required">
                                <option value=""></option>
                                @for((locale of locales$ | async); track locale) {
                                    <option [value]="locale.id">
                                        {{ locale.label | translate }}
                                    </option>
                                }
                            </select>
                            <label class="required" for="locale">{{ 'form.user.fields.society.locale.value' | translate }}</label>
                            @if(societyForm.get('locale').errors && (societyForm.get('locale').dirty || societyForm.get('locale').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('locale').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- Type -->

                        <div class="form-group">
                            <select class="form-control" id="type" formControlName="type" required="required">
                                <option value=""></option>
                                @for((type of types$ | async); track type) {
                                    <option [value]="type.id">
                                        {{ type.label | translate }}
                                    </option>
                                }
                            </select>
                            <label class="required" for="type">{{ 'form.user.fields.society.type.value' | translate }}</label>
                            @if(societyForm.get('type').errors && (societyForm.get('type').dirty || societyForm.get('type').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('type').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Raison sociale -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="corporateName" id="corporateName" required="required">
                            <label for="corporateName">{{'form.user.fields.corporateName.value' | translate}}</label>
                            @if(societyForm.get('corporateName').errors && (societyForm.get('corporateName').dirty || societyForm.get('corporateName').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('corporateName').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- Immatriculation -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="registration" id="immatriculation" [required]="hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])">
                            <label for="immatriculation">{{'form.user.fields.immatriculation.value' | translate}}</label>
                            @if(societyForm.get('registration').errors && (societyForm.get('registration').dirty || societyForm.get('registration').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('registration').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                            @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {
                                <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon> {{ 'form.user.fields.immatriculation.help.value' | translate }}
                                </span>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Code APE -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="businessActivityCode" id="businessActivityCode" >
                            <label for="businessActivityCode">{{'form.user.fields.businessActivityCode.value' | translate}}</label>
                            @if(societyForm.get('businessActivityCode').errors && (societyForm.get('businessActivityCode').dirty || societyForm.get('businessActivityCode').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('businessActivityCode').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- Capital -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="capital" id="capital">
                            <label for="capital">{{'form.user.fields.capital.value' | translate}}</label>
                            @if(societyForm.get('capital').errors && (societyForm.get('capital').dirty || societyForm.get('capital').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('capital').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Siren -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="identificationNumber" id="siren" required="required">
                            <label for="siren">{{'form.user.fields.siren.value' | translate}}</label>
                            @if(societyForm.get('identificationNumber').errors && (societyForm.get('identificationNumber').dirty || societyForm.get('identificationNumber').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('identificationNumber').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <div class="col_12 col_md_6">

                        <!-- immatriculation RCS  -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="rcsRegistration" id="rcsRegistration">
                            <label for="rcsRegistration">{{'form.user.fields.rcsRegistration.value' | translate}}</label>
                            @if(societyForm.get('rcsRegistration').errors && (societyForm.get('rcsRegistration').dirty || societyForm.get('rcsRegistration').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('rcsRegistration').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {

                    <div class="row marges ligne_form">

                        <div class="col_12 col_md_6">

                            <!-- Garantie financière  -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="financialGuarantee" id="financialGuarantee" required="required">
                                <label for="financialGuarantee">{{'form.user.fields.financialGuarantee.value' | translate}}</label>
                                @if(societyForm.get('financialGuarantee').errors && (societyForm.get('financialGuarantee').dirty || societyForm.get('financialGuarantee').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyForm.get('financialGuarantee').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                                <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon> {{ 'form.user.fields.financialGuarantee.help.value' | translate }}
                            </span>
                            </div>
                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Assurance responsabilité civile professionnelle -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="insurancePolicy" id="insurancePolicy" required="required">
                                <label for="insurancePolicy">{{'form.user.fields.insurancePolicy.value' | translate}}</label>
                                @if(societyForm.get('insurancePolicy').errors && (societyForm.get('insurancePolicy').dirty || societyForm.get('insurancePolicy').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyForm.get('insurancePolicy').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                                <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon> {{ 'form.user.fields.insurancePolicy.help.value' | translate }}
                            </span>
                            </div>
                        </div>

                    </div>
                }

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Numéro de TVA -->

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="vatNumber" id="vatNumber">
                            <label for="vatNumber">{{'form.user.fields.vatNumber.value' | translate}}</label>
                            @if(societyForm.get('vatNumber').errors && (societyForm.get('vatNumber').dirty || societyForm.get('vatNumber').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('vatNumber').errors.isRequired) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyForm.get('vatNumber').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                            <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon>
                                {{ 'form.user.fields.vatNumber.help.value' | translate }}
                                </span>
                        </div>
                    </div>
                </div>

                @if(!hasRole('ROLE_OFFER_CREATOR')) {

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">

                            <!-- Logo ETQ User n'ayant pas le rôle Créateur d'offres-->

                            <div class="form-group">
                                <label>{{ 'file.add.action.logo.value' | translate }}</label>
                                @if(societyLogoConfig) {
                                    <form-field-file [config]="societyLogoConfig" [form]="societyForm" [file]="societyForm.get('logo').value"></form-field-file>
                                }
                                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'form.user.fields.logo.help.' + (hasRole('ROLE_OFFER_CREATOR') ? 'offerCreator' : 'distributor') + '.value' | translate }}</span>
                            </div>
                        </div>
                    </div>
                }

                <!-- Adresses -->

                <ng-container formArrayName="addresses">

                    @if(isAddressToDisplay('mailing')) {

                        <div class="row marges ligne_form">

                            <ng-container *ngTemplateOutlet="formAddress;context:{controlIndex: getAddressControlIndexByType('mailing')}"></ng-container>

                        </div>
                    }

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <div class="checkbox">
                                    <input type="checkbox" id="differentBillingAddress" [(ngModel)]="differentBillingAddress" [ngModelOptions]="{standalone: true}" (ngModelChange)="resetAddresses()">
                                    <label for="differentBillingAddress">{{ 'bill.address.different.question.value' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if(isAddressToDisplay('billing')) {

                        <div class="row marges ligne_form">

                            <ng-container *ngTemplateOutlet="formAddress;context:{controlIndex: getAddressControlIndexByType('billing')}"></ng-container>

                        </div>
                    }

                </ng-container>

                <!-- Email générique (pour les échanges clients) -->

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="email"
                                   id="email" required="required">
                            <label for="email">{{'form.user.fields.email.society.value' | translate}}</label>
                            @if(societyForm.get('email').errors && (societyForm.get('email').dirty || societyForm.get('email').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('email').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyForm.get('email').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>

                    </div>
                    <div class="col_12 col_md_6">

                        <!-- Téléphone générique (pour les échanges clients) -->

                        <div class="form-group">

                            <app-core-intl-tel-input [formGroup]="societyForm" [controlName]="'phone'" customPlaceholder="{{'form.user.fields.phone.value' | translate}}"></app-core-intl-tel-input>

                            @if(societyForm.get('phone').errors && (societyForm.get('phone').dirty || societyForm.get('phone').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(societyForm.get('phone').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(societyForm.get('phone').errors.validatePhoneNumber) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <!-- Email de facturation différent -->

                @if(hasRole('ROLE_OFFER_CREATOR')) {

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <div class="checkbox">
                                    <input type="checkbox" id="differentBillingEmail" [(ngModel)]="differentBillingEmail" [ngModelOptions]="{standalone: true}" (ngModelChange)="resetBillingAddress()">
                                    <label for="differentBillingEmail">{{ 'form.user.fields.emailFacturation.title.value' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if(hasRole('ROLE_OFFER_CREATOR') && differentBillingEmail) {

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">

                            <!-- Email de facturation -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="billingEmail" id="billingEmail">
                                <label for="billingEmail">{{'form.user.fields.emailFacturation.value' | translate}}</label>
                                @if(societyForm.get('billingEmail').errors && (societyForm.get('billingEmail').dirty || societyForm.get('billingEmail').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyForm.get('billingEmail').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(societyForm.get('billingEmail').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                }

                @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_OFFER_CREATOR'])) {

                    <div class="row marges ligne_form account_owner">
                        <div class="col_12">
                            <div class="form-group">
                                <div class="checkbox">
                                    <input type="checkbox" id="accountOwner" checked disabled>
                                    <label for="accountOwner">{{ 'user.account.owner.value' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if(userService.hasAccess(user.getValue(), 'ONLINE_SALE') && user.value.society.customInvoiceLegalInformation) {

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Informations juridiques personnalisées -->

                            <div class="form-group">
                                <label>{{ 'user.account.invoices.custom.legalInformation.value' | translate }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">
                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="customInvoiceLegalInformation" id="customInvoiceLegalInformation">
                                <label for="customInvoiceLegalInformation">{{ 'user.account.invoices.custom.legalInformation.value' | translate }}</label>
                                <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon>
                                    {{ 'services.form.gift_voucher.add.customInvoiceLegalInformation.value' | translate }}
                             </span>
                            </div>
                        </div>
                    </div>
                }

                @if(commission) {

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{ ('form.user.fields.commission.title.' + (hasRole('ROLE_OFFER_DISTRIBUTOR') ? 'distributor' : 'default') + '.value') | translate }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12 col_md_6">

                            <!-- Commissions séjour FIT %HT -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.individualStay) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.individualStay.ht.value' | translate}}</label>
                            </div>

                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Commissions séjour FIT %TTC -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.individualStayTTC) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.individualStay.ttc.value' | translate}}</label>
                            </div>

                        </div>

                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12 col_md_6">

                            <!-- Commission offre journée FIT %HT -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.individualDay) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.individualDay.ht.value' | translate}}</label>
                            </div>

                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Commission offre journée FIT %TTC -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.individualDayTTC) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.individualDay.ttc.value' | translate}}</label>
                            </div>

                        </div>

                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12 col_md_6">

                            <!-- Commission séjour Groupe / MICE %HT -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.groupStay) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.groupStay.ht.value' | translate}}</label>
                            </div>

                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Commission séjour Groupe / MICE %TTC -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.groupStayTTC) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.groupStay.ttc.value' | translate}}</label>
                            </div>

                        </div>

                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12 col_md_6">

                            <!-- Commission offre journée Groupe / MICE %HT -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.groupDay) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.groupDay.ht.value' | translate}}</label>
                            </div>

                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Commission offre journée Groupe / MICE %TTC -->

                            <div class="form-group">
                                <input type="text" value="{{ formatCommission(commission.groupDayTTC) }}" class="form-control" disabled>
                                <label>{{'form.user.fields.commission.groupDay.ttc.value' | translate}}</label>
                            </div>

                        </div>

                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12">

                            <!-- Encaissement automatique des commissions -->

                            <div class="form-group">
                                <label>{{'form.user.fields.commission.incomingPayment.description.value' | translate}} {{((commission.incomingPayment ? 'yes' : 'no') + '.value') | translate }}</label>
                            </div>

                        </div>

                    </div>

                    <br>
                }

                @if(user.getValue().society.networkOfferCreators.length) {

                    <!-- Réseaux de créateurs d'offres -->

                    <div class="row ligne_form">
                        <div class="form_part">
                            <p class="title_part">{{ 'network.offerCreator.list.title.value' | translate}}</p>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <span>{{ parsedNetworkOfferCreatorNames }}</span>
                            </div>
                        </div>
                    </div>
                }

                @if(user.getValue().society.societyGroups.length) {

                    <!-- Groupes d'utilisateurs -->

                    <div class="row ligne_form">
                        <div class="form_part">
                            <p class="title_part">{{ 'societyGroup.plural.value' | translate}}</p>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <span>{{ parsedSocietyGroups }}</span>
                            </div>
                        </div>
                    </div>
                }

                @if(user.getValue().society.networkProviders.length) {

                    <!-- Réseaux de prestataires -->

                    <div class="row ligne_form">
                        <div class="form_part">
                            <p class="title_part">{{ 'networkProvider.plural.value' | translate}}</p>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <span>{{ parsedNetworkProviders }}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </ng-container>

    </div>

</ng-template>

<!-- Saisie d'une adresse -->

<ng-template #formAddress let-i="controlIndex">

    @if(getAddressControl(i)) {

        <ng-container [formGroup]="form">

            <ng-container formGroupName="society">

                <ng-container formArrayName="addresses">

                    <ng-container [formGroupName]="indexAsString(i)">
                        <div class="col_12">

                            <div class="row ligne_form">
                                <div class="form_part">
                                    <p class="title_part">{{ 'coordinate.plural.value' | translate}}</p>
                                </div>
                            </div>

                            <div class="row marges ligne_form">
                                <div class="col_6 y_items_center">
                                    <app-core-google-places-location [fields]="getAddressLocationFields(getAddressControl(i))" (onSelection)="selectAddress(i)"></app-core-google-places-location>
                                </div>
                            </div>

                            <div class="row marges ligne_form">
                                <div class="col_12 col_md_6">

                                    <!-- Adresse -->

                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="address" required="required">
                                        <label for="address">{{'form.user.fields.address.value' | translate}}</label>
                                        @if(getAddressControl(i).get('address').errors && (getAddressControl(i).get('address').dirty || getAddressControl(i).get('address').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(getAddressControl(i).get('address').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>

                                <div class="col_12 col_md_6">

                                    <!-- Complément d'adresse -->

                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalAddress" id="additionalAddress">
                                        <label for="additionalAddress">{{'form.user.fields.additionalAddress.value' | translate}}</label>
                                        @if(getAddressControl(i).get('additionalAddress').errors && (getAddressControl(i).get('additionalAddress').dirty || getAddressControl(i).get('additionalAddress').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(getAddressControl(i).get('additionalAddress').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="row marges ligne_form">
                                <div class="col_12 col_md_6">

                                    <!-- Code postal -->

                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="zipcode" id="zipcode" required="required">
                                        <label for="zipcode">{{'form.user.fields.zipcode.value' | translate}}</label>
                                        @if(getAddressControl(i).get('zipcode').errors && (getAddressControl(i).get('zipcode').dirty || getAddressControl(i).get('zipcode').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(getAddressControl(i).get('zipcode').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                    @if(getAddressControl(i).get('zipcode').errors.pattern) {
                                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                                <div class="col_12 col_md_6">

                                    <!-- Ville -->

                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="city" id="city" required="required">
                                        <label for="city">{{'form.user.fields.city.value' | translate}}</label>
                                        @if(getAddressControl(i).get('city').errors && (getAddressControl(i).get('city').dirty || getAddressControl(i).get('city').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(getAddressControl(i).get('city').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="row marges ligne_form">

                                <div class="col_12 col_md_6">

                                    <!-- Région -->

                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="region" id="region" required="required">
                                        <label for="region">{{'form.user.fields.region.value' | translate}}</label>
                                        @if(getAddressControl(i).get('region').errors && (getAddressControl(i).get('region').dirty || getAddressControl(i).get('region').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(getAddressControl(i).get('region').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>

                                <div class="col_12 col_md_6">

                                    <!-- Pays -->

                                    <div class="form-group">
                                        <select class="form-control" id="country" formControlName="country" required="required">
                                            @for((country of countries$ | async); track country) {
                                                <option [value]="country.code">{{ translationService.getFallbackTranslation(country.translations).name }}</option>
                                            }
                                        </select>
                                        <label class="required"
                                               for="country">{{ 'form.user.fields.country.value' | translate }}</label>
                                        @if(getAddressControl(i).get('country').invalid && (getAddressControl(i).get('country').dirty || getAddressControl(i).get('country').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(getAddressControl(i).get('country').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-container>

                </ng-container>

            </ng-container>

        </ng-container>
    }

</ng-template>

<!-- Saisie des documents CGV -->

<ng-template #formTermsAndConditions>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'termsAndConditions.value' | translate }}</span>
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <app-terms-and-conditions [parentTermsAndConditions]="form"></app-terms-and-conditions>

</ng-template>

<!-- Gestion des rôles -->

<ng-template #roleManagement>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'role.management.plural.value' | translate }}</span>
            </div>
        </div>
    </div>

    <div class="content_tab">

        @switch(true) {

            <!-- ETQ Créateur d'offre -->
            @case (hasRole('ROLE_OFFER_CREATOR') && !hasRole('ROLE_OFFER_DISTRIBUTOR')) {

                <div class="add_role">

                    <!-- Ajout du rôle distributeur -->

                    <p>{{ 'role.add.distributor.description.value' | translate }}</p>

                    <p>{{ 'role.add.distributor.description.action.value' | translate }}</p>

                    <button type="button" class="btn_cta btn_little" (click)="addRoleDialog('ROLE_OFFER_DISTRIBUTOR')">
                        {{ 'role.add.distributor.action.value'|translate }}
                    </button>

                </div>

                <!-- Avantages du rôle Distributeur d'offre -->
                        <!--<app-role-advantages
                            [label]="'role.synthesis.distributor.label' | translate"
                            [advantages]="[
                                'role.synthesis.distributor.list.0.value' | translate,
                                'role.synthesis.distributor.list.1.value' | translate,
                                'role.synthesis.distributor.list.2.value' | translate,
                                'role.synthesis.distributor.list.3.value' | translate,
                                'role.synthesis.distributor.list.4.value' | translate,
                                'role.synthesis.distributor.list.5.value' | translate,
                                'role.synthesis.distributor.list.6.value' | translate,
                                'role.synthesis.distributor.list.7.value' | translate
                            ]"></app-role-advantages>
                        -->
            }

            <!-- ETQ Distributeur d'offre -->
            @case(hasRole('ROLE_OFFER_DISTRIBUTOR') && !hasRole('ROLE_OFFER_CREATOR')) {

                <div class="add_role">

                    <!-- Ajout du rôle Créateur d'offre -->

                    <div class="col_12">

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <p [innerHTML]="'user.account.management.beCreator.infos.value' | translate"></p>
                            </div>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <button type="button" class="btn_cta btn_little" (click)="subscriptionDialog()">
                                    {{'user.account.management.beCreator.button.value' | translate}}
                                </button>
                            </div>
                        </div>

                        @if(displayMangopayDocumentsRequirements) {

                            <div class="row marges ligne_form">
                                <div class="col_12">
                                    <p [innerHTML]="'user.account.management.beCreator.mangopay.documents.description.value' | translate"></p>
                                </div>
                            </div>

                            <div class="row marges ligne_form">
                                <div class="col_12">
                                    <button class="btn_cta btn_little" type="button" (click)="goToMangoPayDocuments()">{{ 'service.mangopay.documents.add.action.value' | translate }}</button>
                                </div>
                            </div>
                        }
                    </div>

                </div>

                <!-- Avantages du rôle Créateur d'offre -->
                        <!--<app-role-advantages
                            [label]="'role.synthesis.offerCreator.label' | translate"
                            [advantages]="[
                                'role.synthesis.offerCreator.list.0.value' | translate,
                                'role.synthesis.offerCreator.list.1.value' | translate,
                                'role.synthesis.offerCreator.list.2.value' | translate,
                                'role.synthesis.offerCreator.list.3.value' | translate,
                                'role.synthesis.offerCreator.list.4.value' | translate,
                                'role.synthesis.offerCreator.list.5.value' | translate,
                                'role.synthesis.offerCreator.list.6.value' | translate,
                                'role.synthesis.offerCreator.list.7.value' | translate,
                                'role.synthesis.offerCreator.list.8.value' | translate
                            ]"></app-role-advantages>
                        -->
            }
        }
    </div>

</ng-template>

<!-- Gestion du compte -->

<ng-template #accountManagement>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                @if(hasRole('ROLE_OFFER_CREATOR') && !hasRole('ROLE_OFFER_DISTRIBUTOR')) {
                    <span class="title">{{ 'user.distributor.settings.value' | translate }}</span>
                } @else {
                    <span class="title">{{ 'user.account.settings.value' | translate }}</span>
                }
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="content_tab">

        <!-- ETQ Admin du compte -->

        @if(isAccountAdmin()) {

            @if(societyAdminRequests$ | async; as societyAdminRequests) {

                <div class="row marges">
                    <div class="form_part">
                        <p class="title_part">{{ 'form.user.fields.admin.value' | translate}}</p>
                    </div>
                </div>

                @if(societyAdminRequests.length) {

                    @for(societyAdminRequest of societyAdminRequests; track societyAdminRequest) {
                        <div class="accept_admin">

                            <p>{{ 'user.account.admin.request.user.value' | translate:{
                                lastname: societyAdminRequest.user.lastName,
                                firstname: societyAdminRequest.user.firstName
                            } }}</p>

                            <div class="row marges">
                                <div class="col_content">
                                    <button type="button" class="btn_cta btn_little" (click)="acceptAdminAccountRequestDialog(societyAdminRequest)">
                                        {{ 'user.account.admin.request.accept.action.value'|translate }}
                                    </button>
                                </div>
                                <div class="col_content">
                                    <button type="button" class="btn_cta btn_little btn_red" (click)="cancelAdminAccountRequestDialog(societyAdminRequest)">
                                        {{ 'user.account.admin.request.cancel.action.value'|translate }}
                                    </button>
                                </div>
                            </div>

                        </div>
                    }

                } @else {

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon>
                                    <span>{{ 'user.account.admin.request.no_requests.help.value' | translate }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                }

                <br>
            }
        }

        <!-- ETQ Collaborateur -->

        @if(isCollaborator()) {

            @if(userSocietyAdminRequests$ | async; as requests) {

                @if(requests.length > 0) {

                    <!-- Requête déjà envoyée -->

                    <p>
                        <span>{{ 'user.account.admin.request.done.description.value' | translate }}</span>
                    </p>
                    @for(userSocietyAdminRequest of requests; track userSocietyAdminRequest) {
                        <div>

                            <button type="button" class="btn_cta btn_little" (click)="cancelAdminAccountRequestDialog(userSocietyAdminRequest)">
                                {{ 'user.account.admin.request.cancel.action.value'|translate }}
                            </button>

                        </div>
                    }

                    <br/>

                } @else {

                    <!-- Aucune requête envoyée -->

                    <div class="row marges ligne_form">
                        <div class="form_part">
                            <p class="title_part">{{ 'user.account.admin.request.value.value' | translate}}</p>
                        </div>
                    </div>

                    <div>
                        <p>
                            <span>{{ 'user.account.admin.request.description.value' | translate }}</span>
                        </p>
                        <button type="button" class="btn_cta btn_little" (click)="adminAccountRequestDialog()">
                            {{ 'user.account.admin.request.action.value'|translate }}
                        </button>
                    </div>

                    <br>
                }
            }
        }

        <!-- Préférence d'affichage -->

        @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL'])) {

            <div class="row marges">
                <div class="form_part">
                    <p class="title_part">{{ 'display.preference.value' | translate}}</p>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <div class="app-toggle">
                            <mat-slide-toggle [(ngModel)]="displayPreferenceNetworkOfferCreatorOffersEnabled" (toggleChange)="marketplacePreferenceForm.get('networkOfferCreators').patchValue([])">{{ 'offer.filter.networkOfferCreatorOffers.action.value' | translate}}</mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>

            @if(displayPreferenceNetworkOfferCreatorOffersEnabled) {

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <app-core-network-offer-creator-collection-select [parentForm]="marketplacePreferenceForm" [formName]="'networkOfferCreators'"></app-core-network-offer-creator-collection-select>
                    </div>

                    <div class="col_12">
                        <span class="message-help">
                            <mat-icon class="tooltip_icon">info</mat-icon>
                            {{ 'user.account.marketplacePreferences.networkOfferCreator.help.value' | translate }}
                        </span>
                    </div>
                </div>
            }
        }

        <!-- Nouvelles offres -->

        @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL']) && isAccountAdmin()) {

            <div class="row marges ligne_form">
                <div class="form_part">
                    <p class="title_part">{{ 'offer.plural.new.value' | translate}}</p>
                </div>
            </div>

            <div class="row marges">
                <div class="col_12">
                    <div class="form-group">
                        <div class="app-toggle">
                            <mat-slide-toggle [ngModel]="notificationCreateEnabled" (change)="notificationEnabledUpdate('createOffer', $event)">{{'society.notification.offerCreate.value' | translate}}</mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>

            <br>
        }

        @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL', 'ROLE_PROVIDER']) && isAccountAdmin()) {

            <div class="row marges">
                <div class="col_12">
                    <div class="form-group">
                        <div class="app-toggle">
                            <mat-slide-toggle [checked]="user.getValue().society.autoAddCatalog" (change)="changeAutoAddCatalogToggle('autoAddCatalog', $event)" [disabled]="!isAutoAddCatalogAllowed()">
                                {{ 'society.autoAddCatalog.value' | translate }}
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>

            @if(!isAutoAddCatalogAllowed()) {

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <span class="message-help"><mat-icon>info</mat-icon>
                                {{ 'society.noMarkupWarning.value' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            }

            <br>
        }

        <!-- Modifications sur les offres -->

        @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL', 'ROLE_PROVIDER']) && isAccountAdmin()) {

            <div class="row marges">
                <div class="form_part">
                    <p class="title_part">{{ 'offer.plural.update.value' | translate}}</p>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <div class="app-toggle">
                            <mat-slide-toggle [(ngModel)]="notificationOfferCatalogRemoved" (change)="notificationEnabledUpdate('offerCatalogRemoved', $event)">{{'society.notification.offerCatalogRemoved.value' | translate}}</mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <div class="app-toggle">
                            <mat-slide-toggle [(ngModel)]="notificationEnabled" (change)="notificationEnabledUpdate('updateOffer', $event)">{{'society.notification.notificationEnabled.value' | translate}}</mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container [formGroup]="form">
                <div formGroupName="society" class="row marges ligne_form">
                    <div class="col_12">
                        @if(notificationEnabled) {

                            <ng-container formArrayName="notification">
                                <div class="form-group">
                                    <p class="title-form">{{ 'society.notification.TarifModification.value' | translate }}</p>
                                </div>
                                <div class="form-group">
                                    <input type="number" value="" placeholder=" " class="form-control" formControlName="offerPriceVariation" id="offerPriceVariation">
                                    <label for="offerPriceVariation">{{ 'society.notification.offerPriceVariation.value' | translate }}</label>
                                </div>

                                <div class="form-group">
                                    <p class="title-form">{{ 'society.notification.TextModification.value' | translate }}</p>
                                </div>
                                <div class="form-group">
                                    <div class="app-toggle">
                                        <mat-slide-toggle formControlName="offerTextUpdate">{{'society.notification.offerTextUpdate.value' | translate}}</mat-slide-toggle>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="app-toggle">
                                        <mat-slide-toggle formControlName="offerContentUpdate">{{'society.notification.offerContentUpdate.value' | translate}}</mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <p class="title-form">{{ 'society.notification.giftVoucherModification.value' | translate }}</p>
                                </div>

                                <div class="form-group">
                                    <div class="app-toggle">
                                        <mat-slide-toggle formControlName="giftVoucherUpdate">{{'society.notification.giftVoucherUpdate.value' | translate}}</mat-slide-toggle>
                                    </div>
                                </div>

                            </ng-container>
                        }
                    </div>
                </div>

                <br>
            </ng-container>
        }

    </div>

</ng-template>

<ng-template #card>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'card.myself.value' | translate }}</span>
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="button" (click)="submit({ fragment: 'cardPreview' })">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="content_tab my_card">

        <mat-tab-group #tabGroupCard (focusChange)="onCardTabChange($event)">
            <mat-tab [label]="'data.plural.declarative.value' | translate" data-tag="data">
                <ng-container *ngTemplateOutlet="cardData"></ng-container>
            </mat-tab>
            <ng-container>
                <mat-tab [label]="'profile.mine.see.action.value' | translate" data-tag="preview">
                    <ng-container *ngTemplateOutlet="cardPreview"></ng-container>
                </mat-tab>
            </ng-container>
        </mat-tab-group>

        <ng-template #cardData>

            <ng-container [formGroup]="form">

                <div class="row ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <span class="message-help"><mat-icon>info</mat-icon>{{ 'society.data.warning.value' | translate }}</span>
                        </div>
                    </div>
                </div>

                <ng-container formGroupName="society">

                    <div class="ligne_form">

                        <div class="form_part">

                            <p class="title_part">{{ 'publication.status.value' | translate }}</p>

                            <div class="row ligne_form">

                                <div class="col_12">

                                    <!-- Publié / Dépublié -->

                                    <div class="form-group" formGroupName="information">
                                        <label>{{'society.information.published.value' | translate}}</label>
                                        <div class="radio">
                                            <input type="radio" [value]="false" formControlName="enable" class="form-control" id="enableNo">
                                            <label for="enableNo">{{'form.user.fields.no.value' | translate}}</label>
                                        </div>
                                        <div class="radio">
                                            <input type="radio" [value]="true" formControlName="enable" class="form-control" id="enableYes">
                                            <label for="enableYes">{{'form.user.fields.yes.value' | translate}}</label>
                                        </div>
                                        @if(societyInformationForm.get('enable').errors && (societyInformationForm.get('enable').dirty || societyInformationForm.get('enable').touched)) {
                                            <mat-error style="padding: 0;margin-top: 12px;">
                                                <div class="invalid-feedback">
                                                    @if(societyInformationForm.get('enable').errors.isValid) {
                                                        <div>{{ 'form.control.error.user.enable.configuration.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                        @if(isLocked) {
                                            <div class="row ligne_form">
                                                <div class="col_12">
                                                    <div class="form-group">
                                                        <span class="message-help"><mat-icon>info</mat-icon>{{ 'society.information.published.locked.value' | translate }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="ligne_form">

                        <div class="form_part">

                            <p class="title_part">{{ 'logo.mine.value' | translate }}</p>

                            <div class="row ligne_form">
                                <div class="col_12">

                                    <!-- Logo ETQ Créateur d'offres -->

                                    <div class="form-group">
                                        <label class="required">{{ 'file.add.action.logo.value' | translate }}</label>
                                        @if(societyLogoConfig) {
                                            <form-field-file [config]="societyLogoConfig" [form]="societyForm" [file]="societyForm.get('logo').value"></form-field-file>
                                        }
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'form.user.fields.logo.help.' + (hasRole('ROLE_OFFER_CREATOR') ? 'offerCreator' : 'distributor') + '.value' | translate }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="ligne_form">

                        <div class="form_part">

                            <p class="title_part">{{ 'visual.plural.mine.value' | translate }}</p>

                            <div class="col_12 added_bottom_margin">
                                <div class="form-group">
                                    <span class="message-help"><mat-icon>info</mat-icon>{{ 'account.visual.tooltip.value' | translate }}</span>
                                </div>
                            </div>

                            <div formArrayName="pictures" class="add_picture collection">
                                <div class="row marges">
                                    @for(picture of sortedPictureControls; let j = $index; track picture) {
                                        <div class="col_4">
                                            <div class="removable_item">
                                                <ng-container [formGroupName]="j">
                                                    <div class="ligne_form row">
                                                        <div class="col_content">
                                                            <div class="form-group">
                                                                <form-field-image [config]="picturesConfig" [form]="picture.get('image')" (imageAdded)="pictureCopyright.readOnly = false" (imageDeleted)="pictureCopyright.readOnly = true"></form-field-image>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ligne_form row">
                                                        <div class="col_12">
                                                            <div class="form-group">
                                                                <input #pictureCopyright type="text" value="" placeholder=" " class="form-control" formControlName="copyright" id="copyright_{{j}}" required="required" [readOnly]="true">
                                                                <label for="copyright_{{j}}">{{ 'offer.form.fields.copyright.value' | translate }}</label>
                                                                @if(societyPicturesForm.controls[j].get('copyright').errors && (societyPicturesForm.controls[j].get('copyright').dirty || societyPicturesForm.controls[j].get('copyright').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(societyPicturesForm.controls[j].get('copyright').errors.required) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    @if(societyPicturesForm.controls.length > 1) {
                                                        <button type="button" class="btn_cta btn_lines btn_small move_item up" [disabled]="!isDecreasePicturePositionAllowed(j)" (click)="decreasePicturePosition(j)">
                                                            <mat-icon>arrow_back</mat-icon>
                                                        </button>
                                                        <button type="button" class="btn_cta btn_lines btn_small move_item down" [disabled]="!isIncreasePicturePositionAllowed(j)" (click)="increasePicturePosition(j)">
                                                            <mat-icon>arrow_forward</mat-icon>
                                                        </button>
                                                    }
                                                    <button type="button" class="btn_cta btn_red btn_small remove_item" (click)="removePicture(j)">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </ng-container>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div class="ligne_form">
                                    <button class="btn_cta btn_little" type="button" (click)="addPicture()">{{ 'offer.form.fields.picture.value' | translate }}</button>
                                </div>
                            </div>

                            @if(societyForm.get('pictures').errors && (societyForm.get('pictures').dirty || societyForm.get('pictures').touched)) {
                                <div class="row ligne_form">
                                    <div class="col_12">
                                        <div class="form-group">
                                            <mat-error style="padding: 0;margin-top: 12px;">
                                                <div class="invalid-feedback">
                                                    @if(societyForm.get('pictures').errors.minLengthRequired) {
                                                        <div>{{ 'form.control.error.visual.min.required.value' | translate: { count: 5 } }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>

                    <div class="ligne_form">

                        <div class="form_part">

                            <p class="title_part">{{ 'information.plural.mine.value' | translate }}</p>

                        </div>
                    </div>

                    <ng-container formGroupName="information">

                        <div class="row ligne_form">

                            <div class="col_12">

                                <div class="mat-tab-translations" [ngClass]="societyInformationTranslationBuilder.itemsControl|translationPanelValidationClass:['presentation']">

                                    <ng-container formArrayName="translations">

                                        <mat-tab-group [@.disabled]="true">

                                            @for(_ of societyInformationTranslationBuilder.itemsControl.controls; let it = $index; track it) {
                                                <div>

                                                    <mat-tab label="{{ societyInformationTranslationBuilder.getLocaleLabel(societyInformationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyInformationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['presentation']">

                                                        <ng-container [formGroupName]="societyInformationTranslationBuilder.indexAsString(it)">

                                                            <div class="row ligne_form">
                                                                <div class="col_12">
                                                                    <div class="form-group">
                                                                        <label>{{ 'presentation.value' | translate }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row ligne_form">
                                                                <div class="col_12">

                                                                    <!-- Présentation -->

                                                                    <div class="form-group">
                                                                        <app-ckeditor [form]="societyInformationTranslationBuilder.getItemControlByLocale(societyInformationTranslationBuilder.getItemControl(it).value.locale)" [config]="presentationEditorConfig" [ckeditorConfig]="ckeditorConfig"></app-ckeditor>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </ng-container>
                                                    </mat-tab>
                                                </div>
                                            }
                                        </mat-tab-group>
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="row ligne_form">
                            <div class="col_12">

                                <!-- Labellisé RSE -->

                                <div class="form-group">
                                    <label>{{'rse.labelled.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="hasRseLabel" class="form-control" id="hasRseLabelNo">
                                        <label for="hasRseLabelNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="hasRseLabel" class="form-control" id="hasRseLabelYes">
                                        <label for="hasRseLabelYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if(societyInformationForm.get('hasRseLabel').value) {

                            <div class="row ligne_form">

                                <div class="col_12">

                                    <div class="mat-tab-translations" [ngClass]="societyInformationTranslationBuilder.itemsControl|translationPanelValidationClass:['rseLabel']">

                                        <ng-container formArrayName="translations">

                                            <mat-tab-group [@.disabled]="true">

                                                @for(_ of societyInformationTranslationBuilder.itemsControl.controls; let it = $index; track it) {

                                                    <div>

                                                        <mat-tab label="{{ societyInformationTranslationBuilder.getLocaleLabel(societyInformationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyInformationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['rseLabel']">

                                                            <ng-container [formGroupName]="societyInformationTranslationBuilder.indexAsString(it)">

                                                                <div class="row ligne_form">

                                                                    <div class="col_12">

                                                                        <!-- Label RSE -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="rseLabel" id="rseLabel">
                                                                            <label for="rseLabel">{{ 'rseLabel.value' | translate }}</label>
                                                                            @if(societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').errors && (societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').dirty || societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyInformationTranslationBuilder.getItemControl(it).get('rseLabel').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </ng-container>
                                                        </mat-tab>
                                                    </div>
                                                }
                                            </mat-tab-group>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        }

                        <div class="row ligne_form">

                            <div class="col_6">

                                <!-- Langues parlées -->

                                <div class="form-group">
                                    <mat-select formControlName="spokenLanguages" multiple>
                                        @for(language of societySpokenLanguages; track language) {
                                            <mat-option [value]="language">{{ ('locale.' + language + '.value') | translate }}</mat-option>
                                        }
                                        <mat-option [value]="otherSpokenLanguagesIdentifier">{{ 'other.value' | translate }}</mat-option>
                                    </mat-select>
                                    <mat-label class="required">{{ 'form.user.fields.spokenLanguages.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('spokenLanguages').errors && (societyInformationForm.get('spokenLanguages').dirty || societyInformationForm.get('spokenLanguages').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('spokenLanguages').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        @if(societyInformationForm.get('spokenLanguages').value.includes(otherSpokenLanguagesIdentifier)) {

                            <div class="row ligne_form">

                                <div class="col_12">

                                    <div class="mat-tab-translations" [ngClass]="societyInformationTranslationBuilder.itemsControl|translationPanelValidationClass:['spokenLanguages']">

                                        <ng-container formArrayName="translations">

                                            <mat-tab-group [@.disabled]="true">

                                                @for(_ of societyInformationTranslationBuilder.itemsControl.controls; let it = $index; track it) {

                                                    <div>

                                                        <mat-tab label="{{ societyInformationTranslationBuilder.getLocaleLabel(societyInformationTranslationBuilder.getItemControl(it).value.locale) | translate }}" [labelClass]="societyInformationTranslationBuilder.getItemControl(it)|translationTabValidationClass:['spokenLanguages']">

                                                            <ng-container [formGroupName]="societyInformationTranslationBuilder.indexAsString(it)">

                                                                <div class="row ligne_form">

                                                                    <div class="col_12">

                                                                        <!-- Langues parlées -->

                                                                        <div class="form-group">
                                                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="spokenLanguages" id="translationSpokenLanguages">
                                                                            <label for="translationSpokenLanguages">{{ 'language.plural.other.value' | translate }}</label>
                                                                            @if(societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').invalid && (societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').dirty || societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(societyInformationTranslationBuilder.getItemControl(it).get('spokenLanguages').errors.isRequired) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </ng-container>

                                                        </mat-tab>

                                                    </div>
                                                }

                                            </mat-tab-group>

                                        </ng-container>

                                    </div>

                                </div>

                            </div>
                        }

                        @if(user.getValue().society.networkOfferCreators.length) {

                            <div class="row ligne_form">
                                <div class="col_12">

                                    <!-- Réseaux de créateurs d'offres -->

                                    <div class="form-group">
                                        <label>{{ 'society.networkOfferCreator.member.value' | translate }}</label>
                                        <br>
                                        <ul>
                                            @for(network of networkOfferCreatorNames; track network) {
                                                <li>{{ network }}</li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }

                        <div class="ligne_form">

                            <div class="form_part">

                                <p class="title_part">{{ 'offer.plural.mine.value' | translate }}</p>
                            </div>
                        </div>

                        <div class="row ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <span class="message-help"><mat-icon>info</mat-icon>{{ 'society.data.information.value' | translate }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="row ligne_form">

                            <div class="col_6">

                                <!-- Cibles clientèle -->

                                <div class="form-group">
                                    <mat-select multiple [compareWith]="compareById" formControlName="customerTypologies">
                                        @for(customerTypology of customerTypologies; track customerTypology) {
                                            <mat-option [value]="customerTypology">
                                                {{ translationService.getFallbackTranslation(customerTypology.translations).name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label class="required">{{ 'customer.target.mine.plural.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('customerTypologies').errors && (societyInformationForm.get('customerTypologies').dirty || societyInformationForm.get('customerTypologies').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('customerTypologies').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                    <span class="message-help"><mat-icon>info</mat-icon>{{ 'customer.target.plural.help.value' | translate }}</span>
                                </div>

                            </div>

                        </div>

                        <div class="row ligne_form">

                            <div class="col_6">

                                <!-- Vos destinations -->

                                <div class="form-group">
                                    <app-core-select-group [configuration]="regionSelectConfiguration" [sourceCallback]="regionSelectSourceCallback"></app-core-select-group>
                                    @if(societyInformationForm.get('regions').errors && (societyInformationForm.get('regions').dirty || societyInformationForm.get('regions').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('regions').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        <div class="row ligne_form">

                            <div class="col_6">

                                <!-- Types de séjours -->

                                <div class="form-group">
                                    <mat-select multiple [compareWith]="compareById" formControlName="types">
                                        @for(type of types; track type) {
                                            <mat-option [value]="type">
                                                {{ translationService.getFallbackTranslation(type.translations).label }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label class="required">{{ 'stay.plural.type.plural.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('types').errors && (societyInformationForm.get('types').dirty || societyInformationForm.get('types').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('types').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_6">

                                <!-- Types d’offre -->

                                <div class="form-group">
                                    <mat-select multiple formControlName="durationTypes">
                                        @for(type of durationTypes; track type) {
                                            <mat-option [value]="type">
                                                {{ ('offer.type.' + type + '.value') | translate }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label class="required">{{ 'offer.plural.type.plural.value' | translate }}</mat-label>
                                    @if(societyInformationForm.get('durationTypes').errors && (societyInformationForm.get('durationTypes').dirty || societyInformationForm.get('durationTypes').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyInformationForm.get('durationTypes').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>

                        </div>

                    </ng-container>

                </ng-container>

            </ng-container>

        </ng-template>

        <ng-template #cardPreview>

            <div class="page_offer page_offer_creator" style="margin-top: -12px; padding: 0 12px 0 12px;">

                @if((cardSociety$ | async); as cardSociety) {
                    <app-core-offer-creator-item [item]="cardSociety" [enableTracking]="false"></app-core-offer-creator-item>
                }
            </div>

        </ng-template>

    </div>

</ng-template>

<!-- API Ty-Win -->

<ng-template #tywinApi>

    <ng-container [formGroup]="form">

        <div class="title_tab">
            <div class="row marges h_full x_between">
                <div class="col_content y_items_center">
                    <span class="title">{{ 'api.tywin.value' | translate }}</span>
                </div>
                <div class="col_content y_items_center">
                    <button class="btn_cta btn_little" type="submit">
                        {{ 'form.submit.action.value'|translate }}
                    </button>
                </div>
            </div>
        </div>

        <div class="content_tab">

            <div class="row ligne_form">
                <p>
                    <span>{{ 'user.account.api.tywin.description.value' | translate }}</span>
                </p>
            </div>

            <div class="add_role">
                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <span><label>{{ 'user.account.api.version.current.value' | translate }} : <span class="modify">{{ tywinApiVersion }}</span></label></span>
                        </div>
                    </div>
                </div>
                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <span (click)="copyApiToken()"><label>{{ 'user.account.api.token.value' | translate }} : <span style="cursor: pointer;" class="modify">{{ tywinApiToken }}</span></label></span>
                        </div>
                    </div>
                </div>
                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <span><label>{{ 'user.account.api.documentation.value' | translate }} : <a [href]="tywinApiDocumentationLink" target="_blank"><span class="modify">{{ tywinApiDocumentationLink }}</span></a></label></span>
                        </div>
                    </div>
                </div>
                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <span><label>{{ 'user.account.api.environment.production.beta.value' | translate }} : <a [href]="tywinApiProductionBetaEnvironment" target="_blank"><span class="modify">{{ tywinApiProductionBetaEnvironment }}</span></a></label></span>
                        </div>
                    </div>
                </div>
            </div>

            <br>

            <div class="ligne_form row marges">

                <div class="form_part col_12">

                    <p class="title_part">{{ 'ipAddress.plural.management.value' | translate }}</p>

                    <div class="row ligne_form">
                        <p>
                            <span>{{ 'user.account.api.address.description.value' | translate }}</span>
                        </p>
                    </div>

                    @if(ipsControl.errors && (ipsControl.dirty || ipsControl.touched)) {

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(ipsControl.errors.invalidUnicity) {
                                            <div>{{ 'ipAddress.form.control.error.unicity.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>

                            </div>
                        </div>
                    }

                    @if(ipControls.length) {

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <ng-container formArrayName="ips">

                                    @for(ipControl of ipControls; let i = $index; track i) {

                                        <div class="row marges ligne_form">

                                            <ng-container [formGroupName]="indexAsString(i)">

                                                <!-- Adresse IP -->

                                                <div class="col_3">
                                                    <div class="form-group">
                                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="ip-address-{{i}}">
                                                        <label for="ip-address-{{i}}">{{ 'ipAddress.value' | translate }}</label>
                                                        @if(ipControl.get('address').errors) {
                                                            <mat-error>
                                                                <div class="invalid-feedback">
                                                                    @if(ipControl.get('address').errors.required) {
                                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                    }
                                                                    @if(ipControl.get('address').errors.isInvalid) {
                                                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                                    }
                                                                </div>
                                                            </mat-error>
                                                        }
                                                    </div>
                                                </div>
                                                @if(ipControl.get('isDeletable').value) {

                                                    <div class="col_3 remove_ip">
                                                        <div class="form-group">
                                                            <button mat-button type="button" (click)="removeIpControl(i)">
                                                                <mat-icon>delete</mat-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                }

                                            </ng-container>

                                        </div>
                                    }

                                </ng-container>

                            </div>
                        </div>
                    }

                    <div class="ligne_form">
                        <button class="btn_cta btn_little" type="button" (click)="addIpControl()">{{ 'ipAddress.add.action.value' | translate }}</button>
                    </div>
                </div>

            </div>

        </div>

    </ng-container>

</ng-template>

<!-- Désactivation du compte -->

<ng-template #deactivateAccount>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'user.account.deactivate.value' | translate }}</span>
            </div>
        </div>
    </div>

    <div class="content_tab desactivate_account">

        @switch (true) {

            <!-- Rôle Créateur d'offre & Distributeur d'offre -->
            @case(hasRole('ROLE_OFFER_CREATOR') && hasRole('ROLE_OFFER_DISTRIBUTOR')) {

                <div>
                    <p>
                        <span>{{ 'user.account.deactivate.warn.role.offerCreatorDistributor.self.value' | translate }}</span>
                    </p>
                    @if(!societyDelete) {
                        <button type="button" class="btn_cta btn_little" (click)="desactivativationAccountDialog()">
                            {{'user.account.deactivate.action.value'|translate }}
                        </button>
                    }

                    @if(societyDelete && societyDeleteDate) {

                        <div class="info_desactivate ligne_form">

                            <div class="row">

                                <div class="col_6 y_items_center x_center">
                                    <p>{{'subscription.deleteAccount.value' | translate : {date: societyDeleteDate | date : 'shortDate' : null : localeId}  }}</p>
                                </div>

                                <!-- Annulation de la demande de désactivation --->

                                <div class="col_6 y_items_center x_center">
                                    <button type="button" class="btn_cta btn_little" (click)="cancelDeactivationDialog()">{{'subscription.deleteAccount.cancel.value' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            <!-- Rôle Créateur d'offre -->
            @case(hasRole('ROLE_OFFER_CREATOR') && !hasRole('ROLE_OFFER_DISTRIBUTOR')) {

                <div>
                    <p>
                        <span>{{ 'user.account.deactivate.warn.role.offerCreator.self.value' | translate }}</span>
                    </p>
                    @if(!societyDelete) {
                        <button type="button" class="btn_cta btn_little" (click)="desactivativationAccountDialog()">
                            {{'user.account.deactivate.action.value'|translate }}
                        </button>
                    }

                    @if(societyDelete && societyDeleteDate) {

                        <div class="info_desactivate ligne_form">

                            <div class="row">

                                <div class="col_6 y_items_center x_center">
                                    <p>{{'subscription.deleteAccount.value' | translate : {date: societyDeleteDate | date : 'shortDate' : null : localeId}  }}</p>
                                </div>

                                <!-- Annulation de la demande de désactivation --->

                                <div class="col_6 y_items_center x_center">
                                    <button type="button" class="btn_cta btn_little" (click)="cancelDeactivationDialog()">{{'subscription.deleteAccount.cancel.value' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            <!-- Rôle Distributeur d'offre -->
            @case(hasRole('ROLE_OFFER_DISTRIBUTOR') && !hasRole('ROLE_OFFER_CREATOR')) {

                <div>
                    <p>
                        <span>{{ 'user.account.deactivate.warn.role.offerDistributor.self.value' | translate }}</span>
                    </p>
                    <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                        {{'user.account.deactivate.action.value'|translate }}
                    </button>
                </div>
            }

            <!-- Rôle Prestataire -->
            @case(hasRole('ROLE_PROVIDER')) {

                <div>
                    <p>
                        <span>{{ 'user.account.deactivate.warn.role.provider.self.value' | translate }}</span>
                    </p>
                    <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                        {{'user.account.deactivate.action.value'|translate }}
                    </button>
                </div>
            }

            <!-- Rôle Institutionel -->
            @case(hasRole('ROLE_INSTITUTIONAL')) {

                <div>
                    <p>
                        <span>{{ 'user.account.deactivate.warn.role.provider.self.value' | translate }}</span>
                    </p>
                    <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                        {{'user.account.deactivate.action.value'|translate }}
                    </button>
                </div>
            }

            <!-- Rôle Fédération -->
            @case(hasRole('ROLE_FEDERATION')) {

            <div>
                    <p>
                        <span>{{ 'user.account.deactivate.warn.role.provider.self.value' | translate }}</span>
                    </p>
                    <button type="button" class="btn_cta btn_little" (click)="desactivateAccountDialog()">
                        {{'user.account.deactivate.action.value'|translate }}
                    </button>
                </div>
            }
        }

        <img src="assets/images/bg_desactivate.svg" alt="" title=""/>
    </div>

</ng-template>

<!-- Représentant légal -->

<ng-template #legalRepresentative>

    <div class="title_tab">
        <div class="row marges h_full x_between">
            <div class="col_content y_items_center">
                <span class="title">{{ 'society.legalRepresentative.value' | translate }}</span>
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value'|translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="content_tab">

        <!-- Représentant légal -->

        <ng-container [formGroup]="form">

            <ng-container formGroupName="society">

                <div formGroupName="legalRepresentative">

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Civilité -->

                            <div class="form-group">
                                <label>{{'form.user.fields.civility.title.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="1" formControlName="civility" class="form-control" id="legalRepresentative-civility-mister">
                                    <label for="legalRepresentative-civility-mister">{{'form.user.fields.civility.mister.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="2" formControlName="civility" class="form-control" id="legalRepresentative-civility-madam">
                                    <label for="legalRepresentative-civility-madam">{{'form.user.fields.civility.madam.value' | translate}}</label>
                                </div>
                                @if(societyLegalRepresentativeControl.get('civility').errors && (societyLegalRepresentativeControl.get('civility').dirty || societyLegalRepresentativeControl.get('civility').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('civility').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_4">

                            <!-- Nom -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="lastName" id="legalRepresentativeLastName" required="required">
                                <label for="legalRepresentativeLastName">{{'form.user.fields.lastname.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('lastName').errors && (societyLegalRepresentativeControl.get('lastName').dirty || societyLegalRepresentativeControl.get('lastName').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('lastName').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                        <div class="col_12 col_md_4">

                            <!-- Prénom -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="firstName" id="legalRepresentativeFirstName" required="required">
                                <label for="legalRepresentativeFirstName">{{'form.user.fields.firstname.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('firstName').errors && (societyLegalRepresentativeControl.get('firstName').dirty || societyLegalRepresentativeControl.get('firstName').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('firstName').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <div class="col_12 col_md_4">

                            <!-- Email -->

                            <div class="form-group">

                                <div class="form-group">
                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="email" id="legalRepresentativeEmail" required="required">
                                    <label for="legalRepresentativeEmail">{{'form.user.fields.legalRepresentative.email.value' | translate}}</label>
                                    @if(societyLegalRepresentativeControl.get('email').errors && (societyLegalRepresentativeControl.get('email').dirty || societyLegalRepresentativeControl.get('email').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(societyLegalRepresentativeControl.get('email').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(societyLegalRepresentativeControl.get('email').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12 col_md_4">

                            <!-- Téléphone -->

                            <div class="form-group">

                                <app-core-intl-tel-input [formGroup]="societyLegalRepresentativeControl" [controlName]="'phone'" customPlaceholder="{{'form.user.fields.legalRepresentative.phone.value' | translate}}"></app-core-intl-tel-input>

                                @if(societyLegalRepresentativeControl.get('phone').errors && (societyLegalRepresentativeControl.get('phone').dirty || societyLegalRepresentativeControl.get('phone').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('phone').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(societyLegalRepresentativeControl.get('phone').errors.validatePhoneNumber) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <div class="col_12 col_md_4">

                            <!-- Nationalité -->

                            <div class="form-group">
                                <select class="form-control" id="legalRepresentativeNationality" formControlName="nationality" required="required">
                                    @for((country of countries$ | async); track country) {
                                        <option [value]="country.code">
                                            {{ translationService.getFallbackTranslation(country.translations).name }}
                                        </option>
                                    }
                                </select>
                                <label class="required" for="legalRepresentativeNationality">{{ 'form.user.fields.nationality.value' | translate }}</label>
                                @if(societyLegalRepresentativeControl.get('nationality').invalid && (societyLegalRepresentativeControl.get('nationality').dirty || societyLegalRepresentativeControl.get('nationality').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('nationality').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <div class="col_12 col_md_4">

                            <!-- Date de naissance -->

                            <app-input-date [form]="societyLegalRepresentativeControl" [config]="birthDayConfig"></app-input-date>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_6 y_items_center">
                            <app-core-google-places-location [fields]="getAddressLocationFields(societyLegalRepresentativeControl)"></app-core-google-places-location>
                        </div>

                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">

                            <!-- Adresse -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="address" id="legalRepresentativeAddress" required="required">
                                <label for="legalRepresentativeAddress">{{'form.user.fields.address.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('address').errors && (societyLegalRepresentativeControl.get('address').dirty || societyLegalRepresentativeControl.get('address').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('address').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Complément d'adresse -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalAddress" id="legalRepresentativeAdditionalAddress">
                                <label for="legalRepresentativeAdditionalAddress">{{'form.user.fields.additionalAddress.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('additionalAddress').errors && (societyLegalRepresentativeControl.get('additionalAddress').dirty || societyLegalRepresentativeControl.get('additionalAddress').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('additionalAddress').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">

                            <!-- Code postal -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="zipcode" id="legalRepresentativeZipcode" required="required">
                                <label for="legalRepresentativeZipcode">{{'form.user.fields.zipcode.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('zipcode').errors && (societyLegalRepresentativeControl.get('zipcode').dirty || societyLegalRepresentativeControl.get('zipcode').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('zipcode').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(societyLegalRepresentativeControl.get('zipcode').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                        <div class="col_12 col_md_6">

                            <!-- Ville -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="city" id="legalRepresentativeCity" required="required">
                                <label for="legalRepresentativeCity">{{'form.user.fields.city.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('city').errors && (societyLegalRepresentativeControl.get('city').dirty || societyLegalRepresentativeControl.get('city').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('city').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12 col_md_6">

                            <!-- Région -->

                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="region" id="legalRepresentativeRegion" required="required">
                                <label for="legalRepresentativeRegion">{{'form.user.fields.region.value' | translate}}</label>
                                @if(societyLegalRepresentativeControl.get('region').errors && (societyLegalRepresentativeControl.get('region').dirty || societyLegalRepresentativeControl.get('region').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('region').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <div class="col_12 col_md_6">

                            <!-- Pays -->

                            <div class="form-group">
                                <select class="form-control" id="legalRepresentativeCountry" formControlName="country" required="required">
                                    @for((country of countries$ | async); track country) {
                                        <option [value]="country.code">
                                            {{ translationService.getFallbackTranslation(country.translations).name }}
                                        </option>
                                    }
                                </select>
                                <label class="required" for="legalRepresentativeCountry">{{ 'form.user.fields.country.value' | translate }}</label>
                                @if(societyLegalRepresentativeControl.get('country').invalid && (societyLegalRepresentativeControl.get('country').dirty || societyLegalRepresentativeControl.get('country').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(societyLegalRepresentativeControl.get('country').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <br/>
                @if(hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_PROVIDER'])) {
                    <p>{{ 'services.form.file.infos.society.value' | translate}} </p>
                }
            </ng-container>

        </ng-container>
    </div>

</ng-template>
